export const GET_FACTS_STRUCTURE_M = (preview: boolean) => `
  query {
    insuranceHandbookPageCollection(limit:500, preview:${preview}) {
      items {
        slug
        sys {
          id
        }
        name
        childrenPagesCollection(limit: 20) {
          items {
            sys {
              id
            }
            slug
          }
        }
        heading
        preamble
        mainbody {
          json
        }
      }
    }
  }
`;
